import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';

import { MNTokenPlugin } from './definitions';
import { CAPACITOR_MN_TOKEN_PLUGIN_NAME } from '../pluginConstants';

const MNTokenRaw = registerPlugin<MNTokenPlugin>(CAPACITOR_MN_TOKEN_PLUGIN_NAME);
const MNToken = withBridgedStackTrace(MNTokenRaw, CAPACITOR_MN_TOKEN_PLUGIN_NAME);

export { MNToken };
